import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../services/adminApi';
import { useToast } from '../../hooks/use-toast';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await adminLogin(password);
      if (result.success) {
        toast({
          title: 'Login Successful',
          description: 'Welcome to the admin panel',
          duration: 3000
        });
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast({
        title: 'Login Failed',
        description: 'Invalid password. Please try again.',
        variant: 'destructive',
        duration: 5000
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f0f10] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#4b63eb] rounded-full mb-4">
            <Lock size={32} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-[#f5f5f5] mb-2">Admin Login</h1>
          <p className="text-[#a0a0a0]">Jacksonville Photo Portfolio</p>
        </div>

        <div className="bg-[#1a1a1a] p-8 rounded-lg border border-[#2d3748]">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-[#f5f5f5] mb-2">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-[#0f0f10] border border-[#2d3748] text-[#f5f5f5] rounded focus:border-[#4b63eb] focus:outline-none focus:ring-1 focus:ring-[#4b63eb] transition-colors duration-300"
                placeholder="Enter admin password"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-[#4b63eb] to-[#3b4ec9] text-white py-3 rounded font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#4b63eb]/50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <a href="/" className="text-[#4b63eb] hover:text-[#3b4ec9] text-sm">
            ← Back to Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
